import { Locales } from '@amzn/xb-hooks';
import ja_JP from './ja-JP.json';
import ko_KR from './ko-KR.json';
import id_ID from './id-ID.json';
import es_ES from './es-ES.json';
import pt_BR from './pt-BR.json';
import fr_FR from './fr-FR.json';
import zh_CN from './zh-CN.json';
import zh_TW from './zh-TW.json';
import it_IT from './it-IT.json';
import es_419 from './es-419.json';

const translations: Record<string, Record<string, string>> = {
  [Locales.JAPANESE.code]: ja_JP,
  [Locales.KOREAN.code]: ko_KR,
  [Locales.INDONESIAN.code]: id_ID,
  [Locales.SPANISH_SPAIN.code]: es_ES,
  [Locales.PORTUGUESE_BRAZIL.code]: pt_BR,
  [Locales.FRENCH.code]: fr_FR,
  [Locales.SIMPLIFIED_CHINESE.code]: zh_CN,
  [Locales.TRADITIONAL_CHINESE.code]: zh_TW,
  [Locales.ITALIAN.code]: it_IT,
  [Locales.SPANISH_LATM.code]: es_419,
};

export default translations;
